import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ITechnicalSubmission } from 'types/submissions'
import { submissionApi } from './submissions'

export const technicalSubmissionApi = createApi({
  reducerPath: 'technicalSubmissions',
  baseQuery,
  tagTypes: ['TechnicalSubmissions'],
  endpoints: (builder) => ({
    createTechnicalSubmission: builder.mutation<void, Partial<ITechnicalSubmission>>(
      {
        query: (body) => ({
          url: `/technical-submissions`,
          body,
          method: 'post',
        }),
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          await queryFulfilled
          dispatch(submissionApi.util.invalidateTags(['Submission']))
        },
      }
    ),
  }),
})

export const { useCreateTechnicalSubmissionMutation } = technicalSubmissionApi
